module.exports = __webpack_public_path__ + "static/media/ben-jerry.5ae529ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ben-jerry.jpg
// module id = 368
// module chunks = 0